import React from 'react';
import style from './Alert.module.css';

/**
 * ## Display a little div when an icon to warn the user of something.
 *
 * @param {children} React.ReactNode - The content of the alert.
 * @returns React.ReactNode
 */
function Alert({ children }: { children: React.ReactNode }) {
  return (
    <p className={style.info} data-testid="alert">
      {children}
    </p>
  );
}

export default Alert;
